// src/components/iconMap.js
import { AiOutlineLink } from "react-icons/ai";
import { FaIndustry, FaUsersCog, FaBuilding, FaBullhorn } from "react-icons/fa";
import { FiSettings } from "react-icons/fi";
import { HiOutlineChartBar } from "react-icons/hi";
import { IoNewspaperOutline } from "react-icons/io5";
import { TbChecklist } from "react-icons/tb";
import { BsClipboardCheck } from "react-icons/bs";

export const ICONS = {
  AiOutlineLink,
  FaIndustry,
  FaUsersCog,
  FaBuilding,
  FaBullhorn,
  FiSettings,
  HiOutlineChartBar,
  IoNewspaperOutline,
  TbChecklist,
  BsClipboardCheck,
};

export const renderIcon = (name, props) => {
  const Cmp = ICONS[name];
  return Cmp ? <Cmp {...props} /> : null;
};
